 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-00697568":"c14330b4","chunk-032ee81d":"a9eda85f","chunk-090ec1ef":"2aa1482a","chunk-0b960ee0":"e1c1a988","chunk-2d2172bd":"cd1b1488","chunk-4cc6bf42":"8ff5955c","chunk-b2cd2936":"1badd9ac","chunk-59891b4b":"74fbb3b3","chunk-644e9296":"2401aafe","chunk-693f2867":"205b8902","chunk-0f44cad0":"5ec9aea5","chunk-00978fa7":"0527eecd","chunk-93232234":"66898c3d","chunk-1f6f1a75":"bcc97ecf","chunk-437ce9c8":"da5f6c0d","chunk-0491d15a":"833cdbc8","chunk-357ecd10":"2a7a6432","chunk-3a254c82":"a5c9fc59","chunk-4e4d6534":"1c5f9fa6","chunk-1f8552cc":"0598688e","chunk-62afcca1":"3ebf1306","chunk-2d22693c":"9bfa49ce","chunk-4222e5de":"f8bf0ab3","chunk-2968eae9":"18ed5559","chunk-601b45d0":"7e86838f","chunk-722e2333":"30d72746","chunk-9c25f1ea":"6e80e245","chunk-2d22d3f4":"ab9e231a","chunk-0d615afd":"fd0b9487","chunk-188adc3a":"0129ff7c","chunk-27dd9a6e":"2fb81922","chunk-df2ead5c":"7fbaa38f","chunk-4eec42df":"4a1669eb","chunk-2d0aa281":"1472801e","chunk-2d0ae5d6":"7ce89a16","chunk-2d0da355":"2b4f8818","chunk-2d216ba8":"fa9424dc","chunk-3c1e7ab8":"2efc70cc","chunk-b57fc804":"0727578d","chunk-2a7dbf2d":"3595a539","chunk-2d0a3159":"056bf1f8","chunk-2d0dd7af":"aa7cde2b","chunk-2d0ddba1":"6152eb9a","chunk-2d20864f":"23759e39","chunk-2d22b970":"870638dc","chunk-2d21a841":"b8f9db16","chunk-2dab7d02":"7a74dc5e","chunk-3804297c":"c2385042","chunk-392fa8a0":"d0896c7b","chunk-aa5087a8":"fff6f57c","chunk-397283d8":"e96ce960","chunk-588a8186":"cbdd0e0f","chunk-5e550473":"f1c92479","chunk-6cf6e630":"cef914dd","chunk-7d1c7ffa":"618ff90b","chunk-b0c21b92":"24d22c1b","chunk-bb5199a8":"3e50ee74","chunk-bd08044c":"e5fa6bb7","chunk-d796411a":"52c98c32","chunk-4f409036":"6cb9be41","chunk-f0174638":"57675fda","chunk-198d646e":"19f4ea6e","chunk-2d0cc2ee":"15d96098","chunk-3e2e8798":"00e9ea94","chunk-5b708db8":"c6418dcd","chunk-cdd7454c":"2abcf5a5","chunk-0d85870c":"373bddfc","chunk-15d5b040":"e5161540","chunk-2d2223ef":"07dffd17","chunk-3f454ceb":"3c1a746c","chunk-60c0f67f":"8e6f435a","chunk-78aa6286":"f12a0ed5","chunk-13d1b9be":"377a08f3","chunk-2d209b31":"54072f58","chunk-533258a9":"fbb662eb","chunk-6b4e815d":"a705b719","chunk-7ea86b38":"6d4b40af","chunk-e4b089ee":"f42fb8b1","chunk-6fb4b961":"570b053b","chunk-7025fed6":"71ca7975","chunk-743c2ddb":"a76340f5","chunk-745a3122":"a496ad2d","chunk-7467d5b8":"81acc37a","chunk-7482e5bc":"a45e4312","chunk-74af77ea":"72d835d8","chunk-74b7681c":"af3b4519","chunk-74bb0962":"1d1c34d4","chunk-76f042f8":"cf4c94f3","chunk-774c8cf7":"d2e748d9","chunk-eab6a85a":"15072727","chunk-7457c560":"de003d3e","chunk-6404c3c4":"6c34ff27","chunk-7e009afe":"31ecf284"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-00697568":1,"chunk-032ee81d":1,"chunk-090ec1ef":1,"chunk-0b960ee0":1,"chunk-4cc6bf42":1,"chunk-b2cd2936":1,"chunk-59891b4b":1,"chunk-644e9296":1,"chunk-693f2867":1,"chunk-0f44cad0":1,"chunk-93232234":1,"chunk-1f6f1a75":1,"chunk-437ce9c8":1,"chunk-0491d15a":1,"chunk-357ecd10":1,"chunk-3a254c82":1,"chunk-4e4d6534":1,"chunk-1f8552cc":1,"chunk-62afcca1":1,"chunk-4222e5de":1,"chunk-2968eae9":1,"chunk-601b45d0":1,"chunk-722e2333":1,"chunk-9c25f1ea":1,"chunk-0d615afd":1,"chunk-188adc3a":1,"chunk-27dd9a6e":1,"chunk-4eec42df":1,"chunk-3c1e7ab8":1,"chunk-2a7dbf2d":1,"chunk-2dab7d02":1,"chunk-3804297c":1,"chunk-392fa8a0":1,"chunk-aa5087a8":1,"chunk-397283d8":1,"chunk-588a8186":1,"chunk-5e550473":1,"chunk-6cf6e630":1,"chunk-7d1c7ffa":1,"chunk-b0c21b92":1,"chunk-bb5199a8":1,"chunk-bd08044c":1,"chunk-d796411a":1,"chunk-4f409036":1,"chunk-f0174638":1,"chunk-198d646e":1,"chunk-5b708db8":1,"chunk-cdd7454c":1,"chunk-0d85870c":1,"chunk-15d5b040":1,"chunk-3f454ceb":1,"chunk-60c0f67f":1,"chunk-78aa6286":1,"chunk-13d1b9be":1,"chunk-533258a9":1,"chunk-6b4e815d":1,"chunk-7ea86b38":1,"chunk-e4b089ee":1,"chunk-6fb4b961":1,"chunk-7025fed6":1,"chunk-743c2ddb":1,"chunk-745a3122":1,"chunk-7467d5b8":1,"chunk-7482e5bc":1,"chunk-74af77ea":1,"chunk-74b7681c":1,"chunk-74bb0962":1,"chunk-76f042f8":1,"chunk-774c8cf7":1,"chunk-eab6a85a":1,"chunk-7457c560":1,"chunk-6404c3c4":1,"chunk-7e009afe":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-00697568":"abc2efc1","chunk-032ee81d":"097b5913","chunk-090ec1ef":"21db3db3","chunk-0b960ee0":"f7fa28aa","chunk-2d2172bd":"31d6cfe0","chunk-4cc6bf42":"95dd64be","chunk-b2cd2936":"e1cab62b","chunk-59891b4b":"25e1cee2","chunk-644e9296":"7de0dee6","chunk-693f2867":"0f4fa8af","chunk-0f44cad0":"085a4e18","chunk-00978fa7":"31d6cfe0","chunk-93232234":"9f1f656b","chunk-1f6f1a75":"9a405618","chunk-437ce9c8":"5241011b","chunk-0491d15a":"8f36ba8b","chunk-357ecd10":"feb201d0","chunk-3a254c82":"4173f3f9","chunk-4e4d6534":"097656b9","chunk-1f8552cc":"5b7563f1","chunk-62afcca1":"c9c7b5f7","chunk-2d22693c":"31d6cfe0","chunk-4222e5de":"7e1ecbad","chunk-2968eae9":"832f84b9","chunk-601b45d0":"78fd6491","chunk-722e2333":"f40d1d57","chunk-9c25f1ea":"980236f2","chunk-2d22d3f4":"31d6cfe0","chunk-0d615afd":"800eff7a","chunk-188adc3a":"2c6fc431","chunk-27dd9a6e":"37df1425","chunk-df2ead5c":"31d6cfe0","chunk-4eec42df":"440937b0","chunk-2d0aa281":"31d6cfe0","chunk-2d0ae5d6":"31d6cfe0","chunk-2d0da355":"31d6cfe0","chunk-2d216ba8":"31d6cfe0","chunk-3c1e7ab8":"902d1a8d","chunk-b57fc804":"31d6cfe0","chunk-2a7dbf2d":"effb2c29","chunk-2d0a3159":"31d6cfe0","chunk-2d0dd7af":"31d6cfe0","chunk-2d0ddba1":"31d6cfe0","chunk-2d20864f":"31d6cfe0","chunk-2d22b970":"31d6cfe0","chunk-2d21a841":"31d6cfe0","chunk-2dab7d02":"4de75cc5","chunk-3804297c":"9f69edb5","chunk-392fa8a0":"c40cfcff","chunk-aa5087a8":"d58a879b","chunk-397283d8":"6778cc5a","chunk-588a8186":"6e709d2d","chunk-5e550473":"6e709d2d","chunk-6cf6e630":"ddb6d2a6","chunk-7d1c7ffa":"99672fc4","chunk-b0c21b92":"9e6e7a39","chunk-bb5199a8":"3e025a0f","chunk-bd08044c":"ef0da253","chunk-d796411a":"e13d7cb7","chunk-4f409036":"e640e261","chunk-f0174638":"89b0ff92","chunk-198d646e":"a30408e9","chunk-2d0cc2ee":"31d6cfe0","chunk-3e2e8798":"31d6cfe0","chunk-5b708db8":"b312cb39","chunk-cdd7454c":"bf2327c5","chunk-0d85870c":"2405960a","chunk-15d5b040":"07cc3c21","chunk-2d2223ef":"31d6cfe0","chunk-3f454ceb":"1177320e","chunk-60c0f67f":"d6e63a1f","chunk-78aa6286":"18f5736b","chunk-13d1b9be":"bedc82b4","chunk-2d209b31":"31d6cfe0","chunk-533258a9":"b96a9913","chunk-6b4e815d":"24800e73","chunk-7ea86b38":"50eea547","chunk-e4b089ee":"415e0290","chunk-6fb4b961":"eb89e009","chunk-7025fed6":"62d5df80","chunk-743c2ddb":"0dd2478f","chunk-745a3122":"d7dc1639","chunk-7467d5b8":"97906909","chunk-7482e5bc":"3fc962f4","chunk-74af77ea":"23b17eb2","chunk-74b7681c":"6ff76692","chunk-74bb0962":"06c127ee","chunk-76f042f8":"a3d504dc","chunk-774c8cf7":"93e9293c","chunk-eab6a85a":"17e9dde5","chunk-7457c560":"d4ad834b","chunk-6404c3c4":"e1afda8d","chunk-7e009afe":"94f878d9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://presenter.ahaslides.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
